<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", (event) => {

  function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      const expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
      const name = cname + '=';
      const ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
          }
      }
      
      return '';
  }

  function deleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

 /* 
  function checkFirtEntrance() {
    if (!getCookie("user")) {
      fetch(
        "/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&currency[enabled]=true&currency[exclude]=HUF",
        {
          headers: {
            accept: "/",
            "accept-language": "en-US;q=0.8,en;q=0.7",
            "sec-ch-ua":
            '"Not.A/Brand";v="8", "Chromium";v="114", "Google Chrome";v="114"',
            "sec-ch-ua-mobile": "?0",
            "sec-ch-ua-platform": '"macOS"',
            "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
          },
          referrer: "https://hammer-nutrition.hu/",
          referrerPolicy: "strict-origin-when-cross-origin",
          body: null,
          method: "GET",
          mode: "cors",
          credentials: "include",
        }
      )
      .then((resp) => resp.json())
      .then((data) => {
          let currentCountryHandle = data.detected_values.country.handle;
          let currentCountryName = data.detected_values.country.name;

          // let cookieData = currentCountryHandle + "," + currentCountryName;
          // setCookie("savedCountryData", cookieData, 30);

          handleUI(currentCountryHandle, currentCountryName);
                
        });
    }  else {
          this.changeCurrentCountry(sessionStorage.getItem("redirectedCountry"));
    } 
  }

  function handleUI(currentCountryHandle, currentCountryName) {
    if (currentCountryHandle == 'RO') {
      setCookie('user', 'Already Entered', 1);
      window.location.href = 'http://hammernutrition.ro';
    }
  }
*/
    
  function romanianText() {
    var current_page = window.location.toString();
    var currency = getCookie("currency");
    
    if (currency == "RON" && current_page.includes('cart')) {
      document.querySelector(".romanian-info")?.classList.remove("hidden");
    } else {
      document.querySelector(".romanian-info")?.classList.add("hidden");
    }

  }


//  checkFirtEntrance();


  document.querySelectorAll(".menu-lv-item.has-megamenu").forEach(elem => {
      elem.querySelector(".menu-lv-1__action").addEventListener("mouseover", () => {
          imageUrl = elem.querySelector(".menu-lv-1__action").getAttribute("data-product-image");
        if (imageUrl) {


          elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").setAttribute("src", imageUrl);
          elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").style.display = "block";
        } 
      })
      elem.querySelectorAll(".site-nav-title.menu_mobile_link_2").forEach(childElem => {
          childElem.addEventListener("mouseover", () => {
            childImageUrl = childElem.getAttribute("data-product-image");
          if (childImageUrl) {
            
            elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").setAttribute("src", childImageUrl);
            elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").style.display = "block";

          } 
        })
        childElem.closest(".site-nav-list").querySelectorAll(".site-nav-item.menu-lv-3").forEach(grandchildElem => {
          grandchildElem.addEventListener("mouseover", () => {
            grandchildImageUrl = grandchildElem.querySelector(".site-nav-link").getAttribute("data-product-image");
          if (grandchildImageUrl) {

            elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").setAttribute("src", grandchildImageUrl);
            elem.querySelector(".megamenu_style_1 .site-nav-banner--item a img").style.display = "block";

          } 
          })
        });
      
    });

      elem.addEventListener("mouseout", () => {
          
      })
  });

});
  


